import ClientFeedbackModalSection from '../../components/ClientFeedbackComps/ClientFeedbackModalSection';
import ShowAllClientFeedbacks from '../../components/ClientFeedbackComps/ShowAllClientFeedbacks';
import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ClientFeedbackProvider from '../../contexts/ClientFeedbackProvider';

const ClientFeedback = () => {
  // rendering client feedback page component here
  return (
    <>
      <PageTitle title='Client Feedbacks' />

      <ClientFeedbackProvider>
        <ShowAllClientFeedbacks />
        <ClientFeedbackModalSection />
      </ClientFeedbackProvider>
    </>
  );
};

export default ClientFeedback;
